export const getConsolidatedPdfErrorMessage = (error: unknown): string => {
  if (typeof error === 'string') return error.trim();
  if (!error || typeof error !== 'object') return '';

  const value = error as Record<string, unknown>;
  const response = value.response;
  if (response && typeof response === 'object') {
    const responseData = (response as Record<string, unknown>).data;
    const message = getConsolidatedPdfErrorMessage(responseData);
    if (message) return message;
  }

  if (typeof value.message === 'string' && value.message.trim()) {
    return value.message.trim();
  }
  if (typeof value.error === 'string' && value.error.trim()) {
    return value.error.trim();
  }

  return '';
};
